import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// Sin fila de acciones de ActionDialog: el fondo necesita su propio aire
export const contentStyle = {
  paddingBottom: 32
}

export const Body = styled.div`
  .autocomplete-custom {
    width: 100%;
  }

  label {
    font-size: 14px;
    font-weight: 500;
    color: ${tokens.color.text.label};
  }
`
